import { IAppAction } from "../appAction";

export const homeActions = {
  FETCH_HOME: "FETCH_HOME",
  FETCH_HOME_SUCCESS: "FETCH_HOME_SUCCESS",
  FETCH_HOME_ERROR: "FETCH_HOME_ERROR",
};

export const fetchHome = (): IAppAction => ({
  type: homeActions.FETCH_HOME
});

export const fetchHomeSuccess = (payload: any): IAppAction => ({
  type: homeActions.FETCH_HOME_SUCCESS,
  payload
});

export const fetchHomeError = (error: Error): IAppAction => ({
  type: homeActions.FETCH_HOME_ERROR,
  error
});
